import React from "react"

import {lexicalGetColorNumber} from "../../../../../actions/ge-color-number"
import {ColorPalette} from "../../../../../../../fields3/color-coding/color-coding"
import {BadgeType} from "../../../../highlight/badge/badge-plugin"

type Props = {
    colorStyleType  : BadgeType

    className?      : any
}

export default function IconBGComponent(props: Props){

    let style = {}

    const colorNumber = lexicalGetColorNumber(props.colorStyleType)
    if (!_.isNil(colorNumber)) {
        style = {
            backgroundColor : gd.skin.colors.paleBGColor({
                colorNumber: colorNumber,
                corePalette: ColorPalette.CORE
            })
        }
    }

    const classes = Classes("ico editor-i5-font-color font-color-default ui5-ico-16 with-border", props.className)

    return <div className={classes} style={style}/>
}
